<div class="min-h-screen bg-cloud-mist font-sans flex flex-col">

  <main>
    <div class="tfr-page-shell-narrow py-10 sm:py-14 lg:py-16">
      <a routerLink="/" class="mb-8 inline-flex text-[13px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo">
        ← Volver al inicio
      </a>

      <!-- Header -->
      <div class="mb-12">
        <span class="inline-flex items-center px-3 py-1 rounded-[50px] text-xs font-semibold tracking-wide
                     bg-pale-gray text-glacier-blue mb-5">Legal</span>
        <h1 class="text-[38px] font-bold leading-[1.21] text-midnight-indigo mb-3">Términos y Condiciones</h1>
        <p class="text-[14px] text-steel-gray">Última actualización: {{ updated }}</p>
      </div>

      <!-- Body -->
      <div class="space-y-10 text-[15px] leading-[1.71] text-slate-blue">

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">1. Objeto y ámbito</h2>
          <p>
            Los presentes Términos y Condiciones regulan el acceso y uso de la plataforma
            <strong class="text-midnight-indigo">TimeFlexRent</strong> (en adelante, «la Plataforma»),
            operada bajo la marca TimeFlexRent en España. El uso de la Plataforma implica
            la aceptación íntegra de estos Términos.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">2. Roles de usuario</h2>
          <ul class="space-y-3 list-none pl-0">
            <li class="flex gap-3 p-4 rounded-xl bg-white border border-pale-gray">
              <div class="h-2 w-2 rounded-full bg-action-blue mt-2 shrink-0"></div>
              <div>
                <strong class="text-midnight-indigo">Propietario de espacio (Venue Owner)</strong>
                <p class="mt-1">Persona física o jurídica que publica y gestiona espacios en la Plataforma.
                Es responsable de la veracidad de la información, del cumplimiento de la normativa local
                (licencias de actividad, aforo legal, seguros) y de atender al cliente durante la reserva.</p>
              </div>
            </li>
            <li class="flex gap-3 p-4 rounded-xl bg-white border border-pale-gray">
              <div class="h-2 w-2 rounded-full bg-[#ffa600] mt-2 shrink-0"></div>
              <div>
                <strong class="text-midnight-indigo">Cliente / Usuario</strong>
                <p class="mt-1">Persona física que realiza una reserva a través de la Plataforma.
                Se compromete a usar el espacio conforme a lo contratado y a respetar las normas del propietario.</p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">3. Registro y cuenta de usuario</h2>
          <p>
            Para acceder a las funcionalidades completas es necesario crear una cuenta con datos
            verídicos. El usuario es responsable de mantener la confidencialidad de sus credenciales
            y de toda la actividad realizada desde su cuenta.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">4. Proceso de reserva</h2>
          <p>
            La reserva queda confirmada únicamente cuando el sistema emite una confirmación por escrito.
            Los precios mostrados incluyen IVA salvo indicación contraria. La Plataforma actúa como
            intermediario tecnológico — el contrato de arrendamiento de uso temporal se celebra
            directamente entre Propietario y Cliente.
          </p>
          <p class="mt-3">
            El Propietario es responsable de emitir al Cliente la factura o documento fiscal del
            alquiler mediante sus propios sistemas. TimeFlexRent únicamente factura al Propietario
            la comisión de intermediación y no interviene en la facturación del alquiler.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">5. Cancelaciones y devoluciones</h2>
          <p>
            Las políticas de cancelación y modificación son responsabilidad exclusiva del propietario del espacio. TimeFlexRent actúa únicamente como intermediario tecnológico.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">6. Limitación de responsabilidad</h2>
          <p>
            TimeFlexRent no es propietaria de los espacios listados y no interviene en la
            relación contractual entre Propietario y Cliente. En consecuencia, no será responsable
            de: (i) daños materiales ocurridos en el espacio; (ii) incumplimientos del Propietario
            respecto a licencias o normativa de seguridad; (iii) pérdidas de beneficio de ninguna de
            las partes. La responsabilidad máxima de TimeFlexRent frente a cualquier reclamación no
            excederá el importe de las comisiones abonadas en los 3 meses anteriores al hecho causante.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">7. Propiedad intelectual</h2>
          <p>
            Todos los elementos de la Plataforma (diseño, código, marca) son propiedad de
            TimeFlexRent y están protegidos por la legislación española e internacional sobre
            propiedad intelectual. Los Propietarios conceden a TimeFlexRent una licencia no exclusiva
            para mostrar sus contenidos (textos, imágenes) en la Plataforma.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">8. Legislación aplicable y jurisdicción</h2>
          <p>
            Estos Términos se rigen por la legislación española. Para cualquier controversia,
            las partes se someten a los Juzgados y Tribunales competentes conforme a la
            legislación española, respetando el fuero del usuario consumidor cuando proceda.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">9. Modificaciones</h2>
          <p>
            TimeFlexRent se reserva el derecho de modificar estos Términos con un preaviso de
            15 días comunicado por correo electrónico. El uso continuado de la Plataforma tras ese
            plazo implica la aceptación de los nuevos términos.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">10. Derecho de desistimiento</h2>
          <p>
            Si eres consumidor y deseas ejercer tu derecho de desistimiento sobre una reserva confirmada,
            puedes enviar una solicitud a través del
            <a routerLink="/desistimiento" class="text-action-blue hover:underline">formulario de desistimiento</a>.
            La solicitud queda registrada para revisión; no implica cancelación automática ni reembolso inmediato.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">11. Contacto</h2>
          <p>
            Para cualquier consulta sobre estos Términos, escríbanos a
            <a href="mailto:legal@timeflexrent.com" class="text-action-blue hover:underline">legal&#64;timeflexrent.com</a>.
          </p>
        </section>

      </div>

      <!-- Back link -->
      <div class="mt-14 pt-8 border-t border-pale-gray">
        <a routerLink="/"
           class="inline-flex items-center gap-2 text-[13px] font-medium text-slate-blue
                  hover:text-midnight-indigo transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          Volver al inicio
        </a>
      </div>

    </div>
  </main>

  <app-site-footer />

</div>
